module.exports = __webpack_public_path__ + "static/media/node.b8cb4534.svg";